import Board from "./components/Board";

function App() {
  return <Board />;
}

export default App;
